/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Label_RegistryInputs */

const es_ab_label_registry = /** @type {(inputs: Ab_Label_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de matrícula`)
};

const gl_ab_label_registry = /** @type {(inputs: Ab_Label_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de matrícula`)
};

const en_ab_label_registry = /** @type {(inputs: Ab_Label_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registry list`)
};

/**
* | output |
* | --- |
* | "Registry list" |
*
* @param {Ab_Label_RegistryInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_label_registry = /** @type {((inputs?: Ab_Label_RegistryInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Label_RegistryInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_label_registry(inputs)
	if (locale === "en") return en_ab_label_registry(inputs)
	return es_ab_label_registry(inputs)
});